<template lang="pug">
.container-top-habilidades
  .label Top 3 Habilidades
  .corpo
    .posicao-habilidades(v-for="(item, i) in form" :key="i")
      .header
        .posicao {{ i+1 }}°
          span Posição
        .selecao-cor
          SelectPadrao(:options="getCores" v-model="item.corSelecionada")
      .form
        el-form(class="form-custom-nexa" :model="item" :ref="`formRef${i}`" label-width="100px")
          //- el-form-item(label="Nome da Habilidade")
          //-   el-input(v-model="item.habilidade" placeholder="Sua habilidade")
        .selecao-habilidade
          SelectPadrao(
            :options="getTodasHabilidades" 
            v-model="item.habilidade" 
            label="Nome da Habilidade"
            @input="atualizarNivelPorHabilidade(i, $event)"
          )
      .visualizacao
        .label-visualizacao Visualização
        .area-visualizacao
          .estrelas
            Stars(:size="16" :filled="getNivelStar(item.nivel)" :filledColor="getCorHex(item.corSelecionada)")
          .habilidade {{ item.habilidade }}
          .posicao {{ i+1 }}° lugar
  .btn-salvar
    ButtonPadrao(iconLeft)
      LucideIcon(slot="icon-left" name="Save" :size="16")
      | Salvar Alterações
</template>

<script>
import { mapGetters } from 'vuex'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import SelectPadrao from '@/components/ui/SelectPadrao.vue'
import Stars from '@/components/ui/Stars.vue'

export default {
  name: 'TopHabilidades',
  components: {
    ButtonPadrao,
    SelectPadrao,
    Stars
  },

  computed: {
    ...mapGetters({
      getCores: 'habilidades/cores',
      getNiveis: 'habilidades/niveis',
      getTodasHabilidades: 'habilidades/todasHabilidades'
    })
  },

  data() {
    return {
      form: [
        {
          corSelecionada: 'Amarelo',
          habilidade: '',
          nivel: '',
        },
        {
          corSelecionada: 'Amarelo',
          habilidade: '',
          nivel: ''
        },
        {
          corSelecionada: 'Amarelo',
          habilidade: '',
          nivel: ''
        },
      ]
    }
  },

  methods: {
    atualizarNivelPorHabilidade(index, habilidadeSelecionada) {
      const habilidadeEncontrada = this.getTodasHabilidades.find(h => h.label === habilidadeSelecionada)
      
      if (habilidadeEncontrada) {
        this.form[index].nivel = habilidadeEncontrada.nivel
      }
    },
    getCorHex(cor) {
      switch (cor) {
        case 'Amarelo':
          return '#facc15'
        case 'Azul':
          return '#60a5fa'
        case 'Roxo':
          return '#c084fc'
        case 'Verde':
          return '#4ade80'
        case 'Vermelho':
          return '#f87171'
        case 'Rosa':
          return '#f472b6'
        default:
          return '#facc15'
      }
    },
    getNivelStar(nivel){
      switch (nivel) {
        case 'Iniciando':
          return 0
        case 'Aprendiz':
          return 1
        case 'Praticante':
          return 2
        case 'Profissional':
          return 3
        case 'Professor':
          return 4
        case 'Mestre':
          return 5
        default:
          return 0
      }
    }
  }
}
</script>


<style lang="scss">
.container-top-habilidades{
  width: 100%;
  border: 1px solid $borderColor;
  box-sizing: border-box;
  border-radius: 8px;
  background: $corFundoPadraoDashboard;

  .label{
    font-size: 20px;
    font-weight: 700;
    color: $corVerdeClaro;
    padding: 24px;
  }
  .corpo{
    padding: 0 24px 24px;

    .posicao-habilidades{
      border: 1px solid $borderColor;
      border-radius: 8px;
      background: $corPreto;
      padding: 16px;

      &:not(:last-child){
        margin-bottom: 24px;
      }

      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .posicao{
          font-size: 16px;
          font-weight: 700;
          color: $corVerdeClaro;

          span{
            color: #fff;
            font-weight: 500;
            padding-left: 5px;
          }
        }
        .selecao-cor{
          width: 120px;
        }
      }
      .form{
        width: 100%;

        .selecao-habilidade{
          .select-container{
            .el-select{
              width: 100%;

              .el-input{
                .el-input__inner{
                  background: #000;
                }
              }
            }
          }
        }
      }

      .visualizacao{
        margin-top: 16px;

        .label-visualizacao{
          text-align: left;
          color: #9ca3af;
          line-height: 30px;
          font-size: 14px;
        }
        .area-visualizacao{
          background: $corFundoPadraoDashboard;
          border: 1px solid $borderColor;
          padding: 12px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 8px;

          .estrelas{
            margin-bottom: 8px;
          }

          .habilidade{
            font-size: 14px;
            color: $corBranco;
            font-weight: 500;
          }
          .posicao{
            font-size: 12px;
            color: $corValueInfoContato;
            font-weight: 400;
            margin-top: 4px;
          }
        }
      }
    }


  }

  .btn-salvar{
    padding: 16px 24px 24px;
    box-sizing: border-box;
    border-top: 1px solid $borderColor;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 500px) {
    .btn-salvar{
      justify-content: center;
    }
  }
}
</style>